import { queryOptions, useQuery } from '@tanstack/vue-query';
import type {
  ApiContactPage,
  ApiContactPageEntranceBlock,
  ApiContactPageContactFormBlock,
  ApiContactPageAboutBlock,
  ApiContactPageLocationBlock,
  ApiPaginatedResponse,
} from '@/types';
import { getBlock } from '@/utils/getBlock';

export function contactPageQueryOptions() {
  const { cmsFetch } = useCms();
  return queryOptions({
    queryKey: ['cms', 'pages', 'contact'] as const,
    queryFn: () => cmsFetch<ApiPaginatedResponse<ApiContactPage>>('/api/pages/', {
      type: 'pages.ContactPage',
      fields: '*',
    }),
  });
}

export function useContactPage() {
  const query = useQuery(contactPageQueryOptions());

  const page = computed(() => query.data.value?.items?.[0] ?? null);
  const entrance = computed(() => page.value ? getBlock<ApiContactPageEntranceBlock>(page.value.body, 'entrance') : undefined);
  const contactForm = computed(() => page.value ? getBlock<ApiContactPageContactFormBlock>(page.value.body, 'contact_form') : undefined);
  const about = computed(() => page.value ? getBlock<ApiContactPageAboutBlock>(page.value.body, 'about') : undefined);
  const location = computed(() => page.value ? getBlock<ApiContactPageLocationBlock>(page.value.body, 'location') : undefined);

  return { ...query, page, entrance, contactForm, about, location };
}
